<router-outlet></router-outlet>
<sup class="papi-version">PAPI v{{version.version}} ({{version.hash}})</sup>
